// stores/authStore.js
import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/API-requests/Requests";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    token: null,
    roles: null,
    category: null,
    cartcount: null,
    ordercount: null,
    refresh_token: null,
  }),


  //getters for consistent naming and simplified access

  getters: {
    cartCount: (state) => state.cartcount || 0,
    orderCount: (state) => state.ordercount || 0,
    isAuthenticated: (state) => !!state.token,
    userName: (state) => state.user?.first_name || state.user?.first_name || "",

    userDisplayName: (state) => {
      if (state.user?.full_name) {
        return `${state.user.full_name}`;
      }
      return state.user?.full_name || state.user?.email?.split('@')[0] || 'User';
    },

    userRole: (state) => {
      const role = state.user?.position;
      if (typeof role === 'number') {
        return {1: 'Admin', 2: 'Staff', 3: 'Agent'}[role];
      }
      return role;
    },
    isAdmin: (state) => {
      const role = state.user?.position;
      const category = state.user?.category;
      const roleName = typeof role === 'number' 
        ? {1: 'Admin', 2: 'Staff', 3: 'Agent'}[role] 
        : role;
      return roleName === "Admin" || category === "Admin";
    },
    isAgent: (state) => {
      const role = state.user?.position;
      const category = state.user?.category;
      const roleName = typeof role === 'number' 
        ? {1: 'Admin', 2: 'Staff', 3: 'Agent'}[role] 
        : role;
      return roleName === "Agent" || category === "Agent";
    },
    isStaff: (state) => {
      const role = state.user?.position;
      const category = state.user?.category;
      const roleName = typeof role === 'number' 
        ? {1: 'Admin', 2: 'Staff', 3: 'Agent'}[role] 
        : role;
      return roleName === "Staff" || category === "Staff";
    },
  },

  actions: {
    StoreAuthData(token, user, refresh_token) {
      this.user = user;
      this.token = token;
      this.roles = user.position;
      this.category = user.category;
      this.cartcount = user.cartcount;
      this.ordercount = user.ordercount;
      this.refresh_token = refresh_token;
      axios.defaults.headers.common["Authorization"] = `Bearer ${this.token}`;
    },

    async RefreshAccessToken() {
      try {
        const response = await axios.post(`${API_URL}refresh-token`, {
          refresh_token: this.refresh_token,
        });

        if (!response.data || !response.data.access_token) {
          throw new Error("Invalid token response format");
        }

        this.token = response.data.access_token;
        axios.defaults.headers.common["Authorization"] = `Bearer ${this.token}`;
        return this.token;
      } catch (error) {
        console.error("Error refreshing token:", error);
        this.ResetAuthData();
        throw new Error("Session expired, please log in again.");
      }
    },

    ResetAuthData() {
      this.user = null;
      this.token = null;
      this.roles = null;
      this.category = null;
      this.cartcount = null;
      this.ordercount = null;
      this.refresh_token = null;
      delete axios.defaults.headers.common["Authorization"];
    },
  },
  persist: true,
});